import { connectRoutes } from 'redux-first-router';
import restoreScroll from 'redux-first-router-restore-scroll'
import createHistory from 'history/createBrowserHistory';

// Route Thunks
import { fetchPost, fetchPosts } from 'ducks/posts';
// SPA needs to manually report page views
import * as analytics from 'helpers/analytics';


// "ROUTE ACTIONS"
// The names of all possible routes, doubling as the action types for route changes.
export const HOME_SCREEN = 'HOME_SCREEN';
export const PROJECTS_SCREEN = 'PROJECTS_SCREEN';
export const POSTS_SCREEN = 'POSTS_SCREEN';
export const POST_SCREEN = 'POST_SCREEN';


// Configure redux-first-router
const history = createHistory();

const routesMap = {
	[HOME_SCREEN]: '/',
	[PROJECTS_SCREEN]: '/projects',
	[POSTS_SCREEN]: { path: '/blog', thunk: fetchPosts() },
	[POST_SCREEN]: { path: '/blog/:slug', thunk: fetchPost() }
};


// Generate router functions for redux store.
const { reducer, middleware, enhancer } = connectRoutes(history, routesMap, {
	restoreScroll: restoreScroll(),
	onAfterChange: function handleRouteChange(dispatch, getState, extra) {
		const pathname = extra.action.meta.location.current.pathname;
		analytics.sendPageView(pathname);
	}
});

export { reducer as locationReducer };
export { middleware as routerMiddleware };
export { enhancer as routerEnhancer };



// WEBPACK FOOTER //
// ./src/routes.js